module.exports = __webpack_public_path__ + "img/37-800x800.cc4e17d8.jpg";